import { ReactNode } from "react";

interface CardBadge {
  label: string;
  variant: string;
}

interface CardProps {
  title?: string;
  badge?: CardBadge;
  children: ReactNode;
  className?: string;
}

const Card = ({ title, badge, children, className }: CardProps) => {
  return (
    <section className={className ? `craCard ${className}` : "craCard"}>
      {title ? (
        <header className="craCard__header">
          <h3>{title}</h3>
          {badge ? (
            <span className={`badge ${badge.variant}`}>{badge.label}</span>
          ) : null}
        </header>
      ) : null}
      <div className="craCard__body">{children}</div>
    </section>
  );
};

export default Card;
